import { useEffect, useState } from "react";
import Tableheadpanel from "../shared/components/StudyHall/Tableheadpanel";
import Tableview from "../shared/components/StudyHall/Tableview";
import { apigetallStudyHallapplications } from "../../shared/services/apistudyhall/apistudyhall";

export default function StudyHallApplicationpage () {

    const [tableData, setTableData] = useState();
    const [page, setPage] = useState(1);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [globalFilter, setGlobalFilter] = useState('');
    const [loading, setLoading] = useState(false);
    const [tempFilterValues, setTempFilterValues] = useState([]);

    useEffect(()=>{
        apigetallStudyHallapplications({first, rows, globalFilter}).then((res)=>{
            if(res?.resdata) setTableData(res.resdata);}).catch((err) => console.log(err)).finally(setLoading(false))
    },[first, rows, globalFilter]);

    const onPage = (pages) => {
        setPage(pages);
        // console.log(rows,pages )
        setFirst(pages.first);
        setRows(rows);
    };

    const cusfilter = (field, value) => {
        setcolFilter(prev => ({ ...prev, [field]: {$in:value} }));
        setFirst(0);
    };

    const clearFilter = (event)=>{
        setcolFilter(null);
        setGlobalFilter('')
        setTempFilterValues([])
        setFirst(0)
    }


    return (
        <>
        <Tableheadpanel setGlobalFilter={setGlobalFilter}/>
        <Tableview loading={loading} onPage={onPage} tableData={tableData} totallength={tableData?.totallength} cusfilter={cusfilter}
            clearFilter={clearFilter} tempFilterValues={tempFilterValues} setTempFilterValues={setTempFilterValues} first={first}/>
        </>
    )
}